import React from 'react';

import { Icon } from '../../../Icon';
import { Box, SpacingValue } from '../../../Box';

interface PopupIconProps {
  className?: string;
  mx?: SpacingValue;
}

export const PopupIcon = ({ className, mx = '4' }: PopupIconProps) => (
  <Box className={className} mx={mx}>
    <Icon name="arrow_triangle_down" size="16" color="text.dark.secondary" />
  </Box>
);
